import { render } from "./FundsFlowPage.vue?vue&type=template&id=d25281f6&scoped=true"
import script from "./FundsFlowPage.vue?vue&type=script&lang=js"
export * from "./FundsFlowPage.vue?vue&type=script&lang=js"

import "./FundsFlowPage.vue?vue&type=style&index=0&id=d25281f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d25281f6"]])

export default __exports__